import { IndexedDbModel } from '../../shared/indexedDb/indexedDb.model';

export class UserIndexedDbModel extends IndexedDbModel {

  // Configuration
  public entity = 'user';
  public table = 'users';
  public schema = '++id, remote_id, role_id, name_lcase';
  public sync = false;

  // Fields
  public role_id: number;
  public name: string;
  public name_lcase: string;
  public email: string;
  public locale_id: string;

  // Constructor
  constructor(attributes: Partial<UserIndexedDbModel>) {
    super(attributes);
  }
}
